// Organizations whose students must pick exactly their max number of classmates (not "up to" it) in
// the Asignación de Cursos preferences form. Requested by a single school - every organization not
// listed here keeps today's behavior (any amount between 1 and the max).
//
// Frontend-only: the form won't let the student save with fewer, but the API itself still accepts
// between 1 and the max.
export const COURSE_ASSIGNMENT_EXACT_PREFERENCES_ORGANIZATIONS = [
  35 // SSCC Manquehue
]
